export default "__VITE_ASSET___YNnHva___"